import { GoalEventType } from 'modules/goals/types';
import { useRestPostQuery, UseRestPostQueryQueryOptions } from 'utils/hooks/api';

type QueryGoalMetricsParams = {
  goalId: string;
  startTime: string;
  endTime: string;
  messageTypeIds: number[];
  campaignLabelIds: number[];
  includePrevious: boolean;
  conversionEvent: string;
  eventType: GoalEventType;
};

export type GoalMetric = {
  value: number;
  histogram?: {
    buckets: { time: number; value: number }[];
  };
};

export type GoalMetrics = {
  [key: string]: GoalMetric;
};

export type QueryGoalMetricsResponse = {
  currentMetrics: GoalMetrics;
  previousMetrics?: GoalMetrics;
  associatedMetric?: GoalMetrics;
};

export const MISSION_CONTROL_GOAL_METRICS_URL = '/i/goals/aggregate';

export const useQueryGoalMetrics = (
  params: QueryGoalMetricsParams,
  options?: UseRestPostQueryQueryOptions<QueryGoalMetricsResponse>,
) => {
  const { data, isLoading, isError, error } = useRestPostQuery(
    MISSION_CONTROL_GOAL_METRICS_URL,
    params,
    options,
  );

  return {
    goalMetrics: data ?? {
      currentMetrics: {},
      previousMetrics: {},
      associatedMetric: {},
    },
    isLoading,
    isError,
    error,
  };
};
